import * as React from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import './LoadingOrEmpty.css';


class LoadingOrEmpty extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <div className="Claim-card" id="ClaimCard">
                    <Card>
                        <Card.Body>
                            <div className="container text-center">
                                <br />
                                <br />
                                {this.props.claimsHistory.isLoading && <h3 className='loading-heading mb-10px'>We’re loading your claim onto our system...</h3>}
                                {this.props.claimsHistory.isEmpty && <h3 className='loading-heading mb-10px'>No claims progress yet</h3>}
                                {this.props.claimsHistory.isLoading && <p className="font-weight-normal">Please wait for a few minutes</p>}
                                {this.props.claimsHistory.isEmpty && <p className="font-weight-normal">Looks like you don’t have any claim progress to view at the moment</p>}
                                <br />
                                <br />
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimsHistory: state.claimsHistory,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoadingOrEmpty);
